import React from "react";
import * as XLSX from "xlsx";
import { Button } from "antd";
import dateFormat from "dateformat";

const Excelldownload = ({ data }) => {
  const exportToExcel = () => {
    const excelData = [
      ["SL.", "Phone", "Customer Name", "Invoices", "Bill", "Last Purchase"],
      ...data.map((item, index) => [
        index + 1,
        item.phone ? "88" + String(item.phone) : "N/A",
        item.name || "N/A",
        item.total_invoices || 0,
        item.total_amount || 0,
        item.last_purchase_date
          ? dateFormat(item.last_purchase_date, "dd-mm-yyyy")
          : "N/A",
      ]),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    // Set Phone column (index 1) to text format to preserve leading zeros
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: 1 });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].t = "s"; // Set cell type to string
        worksheet[cellAddress].z = "@"; // Set cell format to text
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Report");
    XLSX.writeFile(workbook, "Customer_Report.xlsx");
  };

  return (
    <Button
      type="primary"
      style={{ width: "100%", backgroundColor: "green" }}
      onClick={exportToExcel}
      disabled={data.length === 0}
    >
      XLSX
    </Button>
  );
};

export default Excelldownload;
